import { Component, inject } from "@angular/core";
import { CustomersService } from "src/app/customers/customers.service";
import { DataService } from "../data.service";

@Component({
  selector: "app-customers",
  templateUrl: "./customers.component.html",
  styleUrls: ["./customers.component.css"],
})
export class CustomersComponent {
  _customersService = inject(CustomersService);
  _dataService = inject(DataService);
  colDefs = [
    {
      headerName: "id",
      field: "customerId",
      hide: true,
    },
    {
      headerName: "Tərəf-Müqabil",
      field: "name",
      sortable: true,
      flex: 1,
      filterValueGetter: (params) =>
        this._dataService.latinizeText(params, "customerName"),
    },
    {
      headerName: "Tipi",
      field: "customerGroupId",
      sortable: true,
      flex: 1,
      cellRenderer: (params) => {
        return (
          this._dataService.customerGroups().find((c) => c.id == params.value)
            ?.name || ""
        );
      },
    },
    {
      headerName: "Məlumat",
      field: "details",
      sortable: true,
      flex: 1,
    },
    {
      headerName: "Balans",
      field: "balance",
      sortable: true,
      flex: 1,
      cellRenderer: (params) => {
        return params.value ?? '-';
      }
    },
  ];
  navButtons = [
    {
      name: "Yeni Tərəf-Müqabil",
      icon: "add",
      function: () => this._customersService.customerDialog(),
    },
  ];

  ngOnInit() {
    console.log(this._dataService.customers());
  }

  rowClicked(e) {
    console.log(e);
    this._customersService.customerDialog({ ...e.data, customerId: e.data.id });
  }
}
